// src/auth/firebaseClient.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// ⬇️ paste your own config from Firebase console
const firebaseConfig = {
  apiKey: "AIzaSyB35aT0aDfyL3o-QvYTwIqQljNyG5DnFzE",
  authDomain: "aacbt-1e803.firebaseapp.com",
  projectId: "aacbt-1e803",
  storageBucket: "aacbt-1e803.firebasestorage.app",
  messagingSenderId: "314427468091",
  appId: "1:314427468091:web:fbf2bce3eb4adba499ef1e",
  measurementId: "G-0R5YJM2FCG"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
